<template lang="pug">
#FeatureInfo.absolute.bg-white.ba.b--gray.pa2.f4.br3.shadow-3(:class="{ visible: show }")
    div(v-if="p")
        span.b {{ p.Name_rgn }}
        span(v-if="p.altname") , or
            span.b  {{ p.altname }}
            span ,
        span  is {{ classArticle }}.
        span(v-if="official == 2")  The area is not official but under consideration.
        span(v-if="official == 3")  The area is not official but under consideration.
        span(v-if="official == 4")  The area is not official but under consideration.
        span(v-if="official == 5")  The area is not official but under consideration.
        span(v-if="official == 6")  The designation is unofficial.
        span(v-if="official == 9")  The designation is unofficial.

</template>

<script>
import { EventBus } from '../EventBus';
import indefinite from 'indefinite';
export default {
    name: 'FeatureInfo',
    data: () => ({
        feature: undefined,
        show: false,
        ignoreProps: ['id', 'Longitude', 'Latitude', 'image_url'],
    }),
    computed: {
        p() {
            console.log(this.feature && this.feature.properties);
            return this.feature && this.feature.properties;
        },
        official() {
            return this.p.official || this.p.Official;
        },
        imageUrl() {
            return this.p && this.p.image_url;
        },
        classArticle() {
            return this.p && indefinite(this.p.class);
        },
    },
    created() {
        window.app.FeatureInfo = this;
        EventBus.$on('select-feature', (feature) => {
            if (!feature) {
                this.show = false;
            } else {
                this.feature = feature;
                this.show = true;
            }
        });
    },
};
</script>

<style scoped>
#FeatureInfo {
    transition: opacity 0.3s;
    opacity: 0;
    left: 10px;
    top: 55px;
    margin-right: 44px;
}

@media only screen and (max-width: 639px) {
    #FeatureInfo {
        top: 70px;
    }
}

#FeatureInfo.visible {
    opacity: 1;
    transition: opacity 0.3s;
    /* display: block; */
}
#FeatureInfo th {
    text-align: right;
}

.image {
    width: 100%;
}
</style>
